import classname from 'classname';
import Input from 'components/input';
import Drawer from 'components/drawer';
import Button from 'components/Form/Button';
import FormGroup from 'components/Form/FormGroup';
import Label from 'components/Form/Label';
import Radio from 'components/Form/Radio';
import Switch from 'components/Form/Switch';
import TextArea from 'components/Form/TextArea';
import {
  EmailIcon,
  LongTextIcon,
  ShortTextIcon,
  NumberIcon,
  DateIcon,
  ImageIcon,
  FileIcon,
  DropdownIcon,
  AssociatedFieldIcon,
} from 'components/icons';
import React, { useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { globalStyles } from 'styles';
import styles from './formbuildersettings.module.scss';
import ImageUpload from 'components/image-upload';
import { useDispatch } from 'react-redux';
import { showToast } from 'store/actions/toast';
import { sampleAssociatedFile } from 'data';
import axios from 'axios';

const nameToIcon = {
  SHORT_TEXT: <ShortTextIcon />,
  LONG_TEXT: <LongTextIcon />,
  EMAIL: <EmailIcon />,
  NUMBER: <NumberIcon />,
  CUSTOMER_PHONE_NUMBER: <NumberIcon />,
  DATE: <DateIcon />,
  IMAGE: <ImageIcon />,
  DOCUMENT: <FileIcon />,
  DROPDOWN: <DropdownIcon />,
  ASSOCIATED_FIELD: <AssociatedFieldIcon />,
};

const nameToLabel = {
  SHORT_TEXT: 'Short Text',
  LONG_TEXT: 'Long Text',
  EMAIL: 'Email',
  NUMBER: 'Number',
  CUSTOMER_PHONE_NUMBER: 'Phone Number',
  DATE: 'Date',
  IMAGE: 'Image',
  DOCUMENT: 'Document',
  DROPDOWN: 'Dropdown',
  ASSOCIATED_FIELD: 'Associated Field',
};

export default function FormBuilderSettings({
  drawerActive,
  setDrawerActive,
  currentFiedType,
  updateFieldTypeItem,
  handleDeleteField,
  isOnboarding,
}) {
  const [req, setReq] = useState(false);
  const [doc, setDoc] = useState('');
  const { handleSubmit, errors, register, reset, control } = useForm({
    defaultValues: { required: false },
  });
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    reset(currentFiedType);
    if (currentFiedType.documentTypes) {
      setDoc(currentFiedType.documentTypes.toString());
    }
  }, [currentFiedType, reset]);

  const onSubmit = (values) => {
    updateFieldTypeItem('yes', { ...values, id: currentFiedType.id });
    setReq(false);
  };

  const extractOptions = Array.isArray(currentFiedType?.subFields)
    ? currentFiedType?.subFields.map((res) => {
        return res.value + '\n';
      })
    : currentFiedType?.subFields;

  const fetchFile = () => {
    axios({
      url: window._env_.REACT_APP_ASSOCIATED_FIELDS_SAMPLE,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Sample Associatd Fields.xlsx');
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Drawer
          drawerActive={drawerActive}
          setDrawerActive={setDrawerActive}
          title="Configure Item"
        >
          <Drawer.DrawerBody>
            {currentFiedType.type !== 'ASSOCIATED_FIELD' ? (
              <Input
                label={nameToLabel[currentFiedType?.type]}
                type={'text'}
                placeholder="Enter label text here"
                name={'value'}
                style={{ backgroundColor: '#F7F9FC' }}
                ref={register({
                  required: 'Label text required',
                })}
                prependIcon={<i>{nameToIcon[currentFiedType?.type]}</i>}
                error={errors['value']?.message}
                defaultValue={currentFiedType?.value}
              />
            ) : null}
            {currentFiedType.type !== 'ASSOCIATED_FIELD' ? (
              <Input
                label={'Hint text'}
                type="text"
                placeholder="Enter hint text here"
                name="hint"
                error={errors['hint']?.message}
                style={{ backgroundColor: '#F7F9FC' }}
                ref={register({
                  required: 'Hint text required',
                })}
                defaultValue={currentFiedType?.hint}
              />
            ) : null}

            {/* Multi Select Toggle */}
            {currentFiedType.type === 'DROPDOWN' ? (
              <div
                style={{ margin: '20px 0px 20px 0px' }}
                className={`${globalStyles.flex} ${globalStyles.alignItemsCenter}`}
              >
                <Label>Multi-Select? </Label>
                <div className={styles.status}>
                  <p
                    className={
                      currentFiedType.allowMultiSelect ? styles.active : ''
                    }
                  >
                    No
                  </p>
                  <Controller
                    name="allowMultiSelect"
                    defaultValue={currentFiedType.allowMultiSelect}
                    control={control}
                    render={({ name, onBlur, onChange, value }) => {
                      return (
                        <Switch
                          name={name}
                          checked={value}
                          onBlur={onBlur}
                          onChange={(e) => {
                            onChange(e.target.checked);
                          }}
                        />
                      );
                    }}
                  />
                  <p
                    className={
                      !currentFiedType.allowMultiSelect ? styles.active : ''
                    }
                  >
                    Yes
                  </p>
                </div>
              </div>
            ) : null}

            {/* Number fields */}
            {currentFiedType.type === 'NUMBER' ? (
              <Input
                label={'Max Characters'}
                type="number"
                placeholder="Enter max characters here"
                name="max"
                error={errors['max']?.message}
                style={{ backgroundColor: '#F7F9FC' }}
                ref={register({
                  required: 'Enter max characters here here',
                })}
                defaultValue={currentFiedType?.max}
              />
            ) : null}

            {/* DROPDOWN */}

            {currentFiedType.type === 'DROPDOWN' ? (
              <FormGroup>
                <Label>Enter options here</Label>
                <TextArea
                  name="options"
                  ref={register({
                    required: false,
                  })}
                  defaultValue={extractOptions && extractOptions.join('')}
                ></TextArea>
              </FormGroup>
            ) : null}

            {/* Document type radio */}
            {currentFiedType.type === 'DOCUMENT' ? (
              <div
                className={classname(globalStyles.flex, styles.amountRadio)}
                style={{ margin: '20px 0px 20px 0px' }}
              >
                <div className={styles.amountRadioItem}>
                  <Radio
                    name="documentTypes"
                    changed={() => {
                      updateFieldTypeItem('no', {
                        ...currentFiedType,
                        id: currentFiedType.id,
                        documentTypes: 'PDF',
                      });
                      setDoc('PDF');
                    }}
                    id="1"
                    isSelected={doc === 'PDF'}
                    value={currentFiedType?.documentTypes}
                  >
                    PDF
                  </Radio>
                </div>
                <div className={styles.amountRadioItem}>
                  <Radio
                    name="documentTypes"
                    id="2"
                    isSelected={doc === 'EXCEL'}
                    changed={() => {
                      updateFieldTypeItem('no', {
                        ...currentFiedType,
                        id: currentFiedType.id,
                        documentTypes: 'EXCEL',
                      });
                      setDoc('EXCEL');
                    }}
                    value={currentFiedType?.documentTypes}
                  >
                    EXCEL
                  </Radio>
                </div>
                <div className={styles.amountRadioItem}>
                  <Radio
                    name="documentTypes"
                    id="3"
                    changed={() => {
                      updateFieldTypeItem('no', {
                        ...currentFiedType,
                        id: currentFiedType.id,
                        documentTypes: 'WORD',
                      });
                      setDoc('WORD');
                    }}
                    isSelected={doc === 'WORD'}
                  >
                    WORD
                  </Radio>
                </div>
              </div>
            ) : null}
            {currentFiedType.type === 'ASSOCIATED_FIELD' &&
            currentFiedType.name !== 'State & LGA' ? (
              <div>
                <p className={styles.associatedTitle}>
                  Download CSV Sample to upload
                </p>
                <p className={styles.associatedDescription}>
                  To use an associated field, you will need to download the
                  sample below and upload after you have filled them. We will
                  save your progress as draft so you won’t miss anything while
                  getting the associated fields ready.
                </p>

                <Button
                  type="button"
                  className={styles.associatedButton}
                  onClick={fetchFile}
                >
                  Download Sample Excel File
                </Button>

                <div class={styles.separator}>OR</div>
                <ImageUpload
                  text="Upload Excel File"
                  name="associatedFieldExcelId"
                  value={currentFiedType?.associatedFieldExcelId}
                  type="file"
                  onUpload={(value, id) => {
                    updateFieldTypeItem('no', {
                      ...currentFiedType,
                      associatedFieldExcelId: id,
                    });
                  }}
                  onError={() => {
                    dispatch(
                      showToast('error', 'Error uploading file', 'Try again'),
                    );
                    setError(true);
                  }}
                  error={errors['associatedFieldExcelId']?.message}
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  allowFile
                />
              </div>
            ) : null}

            {currentFiedType.type === 'ASSOCIATED_FIELD' &&
            currentFiedType.name === 'State & LGA' ? (
              <div>
                <p className={styles.associatedTitle}>STATE AND LGA</p>
                <p className={styles.associatedDescription}>
                  A dropdown containing State and LGA will be shown on the agent
                  app. Click on the save button to add this field.
                </p>
              </div>
            ) : null}

            <div
              className={`${globalStyles.flex} ${globalStyles.alignItemsCenter}`}
            >
              <Label>Required field? </Label>
              <div className={styles.status} style={{ marginLeft: '15px' }}>
                <p className={currentFiedType.required ? styles.active : ''}>
                  No
                </p>
                <Controller
                  name="required"
                  defaultValue={currentFiedType.required}
                  control={control}
                  render={({ name, onBlur, onChange, value }) => {
                    return (
                      <Switch
                        name={name}
                        checked={value}
                        onBlur={onBlur}
                        onChange={(e) => {
                          onChange(e.target.checked);
                          setReq(e.target.checked);
                        }}
                        disabled={
                          currentFiedType.type === 'CUSTOMER_PHONE_NUMBER'
                        }
                      />
                    );
                  }}
                />
                <p className={!currentFiedType.required ? styles.active : ''}>
                  Yes
                </p>
              </div>
            </div>

            {!isOnboarding && (req || currentFiedType.required) ? (
              <div
                className={`${globalStyles.flex} ${globalStyles.alignItemsCenter}`}
                style={{ marginTop: '20px' }}
              >
                <Label>Lookup required? </Label>
                <div className={styles.status}>
                  <p
                    className={
                      currentFiedType.lookupRequired ? styles.active : ''
                    }
                  >
                    No
                  </p>
                  <Controller
                    name="lookupRequired"
                    defaultValue={currentFiedType.lookupRequired}
                    control={control}
                    render={({ name, onBlur, onChange, value }) => {
                      return (
                        <Switch
                          name={name}
                          checked={value}
                          onBlur={onBlur}
                          onChange={(e) => onChange(e.target.checked)}
                        />
                      );
                    }}
                  />
                  <p
                    className={
                      !currentFiedType.lookupRequired ? styles.active : ''
                    }
                  >
                    Yes
                  </p>
                </div>
              </div>
            ) : null}
          </Drawer.DrawerBody>
          <Drawer.DrawerFooter>
            <div
              className={classname(
                globalStyles.flex,
                globalStyles.justifyContentBetween,
              )}
            >
              {currentFiedType.type !== 'CUSTOMER_PHONE_NUMBER' && (
                <Button
                  variant="dangerplain"
                  style={{ flex: 1 }}
                  onClick={() => handleDeleteField(currentFiedType.id)}
                >
                  Delete Field
                </Button>
              )}

              <Button style={{ flex: 1 }} variant="primary" type="submit">
                Save and close
              </Button>
            </div>
          </Drawer.DrawerFooter>
        </Drawer>
      </form>
    </div>
  );
}
